<template>
  <div>
    <el-card class="search-form-card">
        <el-form :inline="true" :model="form" class="search-form">
          <el-row>

            <el-col :span="6">
              <el-form-item label="日期:">
                <el-date-picker
                  v-model="createTime"
                  type="month"
                  value-format="yyyy-MM"
                  @change="pickerChange"
                  :picker-options="pickerOptions"
                  placeholder="选择日期">
                </el-date-picker>
                <!-- <el-date-picker
                  v-model="createTime"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份">
                </el-date-picker> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                  <el-button type="primary" @click="loadData">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                  <el-button @click="exportTable('personStatis','派工统计')" type="primary">导出表格</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="11" class="tipText">
                <el-popover
                    placement="top-start"
                    title="表头公式解析"
                    width="400"
                    trigger="hover"
                    >
                    <p class="tipTextP">派工单完成率= (派工完成次数 / 派工次数) * 100%</p>
                    <p class="tipTextP">派工单完成情况分数= 派工单完成率 * 100</p>
                    <p class="tipTextP">按时完成率= [(派工次数 - 派工未按时完成次数) / 派工次数] * 100%</p>
                    <!-- <p class="tipTextP">按时完成分数= [(按时完成率 - 0.8) / 0.2] * 100</p> -->
                    <p class="tipTextP">按时完成分数= 按时完成率 * 100</p>
                    <p class="tipTextP">用户满意度= (非常满意次数 / 完成次数)  * 100%</p>
                    <p class="tipTextP">验收情况分数= {1 - [其它次数  / (完成次数 * 0.2)]} * 100</p>
                    <p class="tipTextP">派工系数= 派工次数 / 全组人员最多派工次数</p>
                    <p class="tipTextP">总分数= 派工完成情况分数 * 0.4 + 按时完成情况分数 * 0.3 + 验收情况分数 * 0.1 + 系数比重分数 * 0.2</p>
                    <div class="tipDiv" slot="reference">
                        派工相关表头公式
                        <i class="el-icon-question"></i>
                    </div>
                </el-popover>

                <!-- <el-popover
                  placement="top-start"
                  title="表头公式解析"
                  width="400"
                  trigger="hover">
                  <p class="tipTextP">迟到/早退<span>1</span>人次扣<span>1</span>分，缺勤1人次扣2分</p>
                  <p class="tipTextP">出勤率= 1 - (迟到/早退 - 缺勤人次 * 2) / 工作日</p>
                  <p class="tipTextP">公司扣分= 100 - 100 * 出勤率</p>
                  <div class="tipDiv" slot="reference">
                    出勤相关表头公式
                    <i class="el-icon-question"></i>
                  </div>
                </el-popover>  -->

            </el-col>
          </el-row>

        </el-form>
    </el-card>
    <el-card>
      <el-table :data="tableData" v-loading="loading" id="personStatis"
      :header-cell-style="tableHeaderCellStyle">
          <el-table-column label="运维组" width="100" align="center" fixed>
              <el-table-column label="人员姓名" prop="user_cname" fixed align="center" width="100"></el-table-column>
          </el-table-column>

          <el-table-column label="派工完成情况(40%)" align="center">
              <el-table-column label="派工次数" prop="total_count" fixed align="center"></el-table-column>
              <el-table-column label="完成次数" prop="complete_count" fixed align="center"></el-table-column>
              <el-table-column label="派工完成率" prop="complete_rate" fixed align="center"></el-table-column>
              <el-table-column label="分数" prop="complete_score" fixed align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="按时完成情况(30%)" align="center">
              <el-table-column label="未按时完成次数" prop="overtime_count" align="center" width="120"></el-table-column>
              <el-table-column label="按时完成率" prop="on_time_rate" align="center"></el-table-column>
              <el-table-column label="分数" prop="on_time_score" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="验收情况(10%)" align="center">
              <el-table-column label="非常满意" prop="very_satisfied_count" align="center"></el-table-column>
              <el-table-column label="其它" prop="other_satisfied_count" align="center"></el-table-column>
              <el-table-column label="用户满意度" prop="satisfied_rate" align="center"></el-table-column>
              <el-table-column label="分数" prop="satisfied_score" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="系数比重(20%)" align="center">
              <el-table-column label="派工系数" prop="coefficient" align="center"></el-table-column>
              <el-table-column label="分数" prop="coefficient_score" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="总分数" align="center">
              <template slot-scope="scope">
                <b>{{scope.row.total_score}}</b>
              </template>
          </el-table-column>
          <!-- <el-table-column label="总分数" show-overflow-tooltip align="center">
              <el-table-column label="（10%+30%+40%+20%）" prop="total_score" align="center" width="180"></el-table-column> -->
              <!-- <template slot-scope="scope">
                {{scope.row.total_score}}
              </template> -->
          <!-- </el-table-column> -->
          <el-table-column label="年 / 月" prop="" align="center">
            <template slot-scope="scope">
              {{scope.row.year}} <span>/</span> {{scope.row.month}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="考勤出勤情况" width="110" align="center">
              <el-table-column label="退到、早退" prop="late_or_early_times" align="center"></el-table-column>
               <el-table-column label="缺勤次数 " prop="incomplete_times" align="center"></el-table-column>
                <el-table-column label="出勤率" prop="attendance_rate" align="center"></el-table-column>
                 <el-table-column label="公司扣分" prop="deduct_score" align="center"></el-table-column>
          </el-table-column> -->
      </el-table>
    </el-card>

  </div>
</template>

<script>
    import services from "./personStatis.service";
    // import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    year:'',
                    month:'',
                },
                tableData:[],
                loading:true,
                dispatchVisible:false,
                createTime:'',
                pickerOptions: {
                  disabledDate(time) {
                    // console.log(time)
                    return time.getTime() >= (Date.now()-8.64e7);
                    // return time.getTime() > Date.now();
                  }
                }
            }
        },
        created() {
            this.request();
        },
        computed:{
            // dictionary(){
            //     return this.$store.state.dictionary;
            // },

        },
        methods: {
            tableHeaderCellStyle({row,column,rowIndex, columnIndex}) {
                let cellStyle1;
                let cellStyle2;
                let cellStyle3;
                let cellStyle4;
                let cellStyle5;
                cellStyle1= "color: #000;background:#F0FCE3;font-weight:600;"
                cellStyle2= "color: #000;background:#ACE1F6;font-weight:600;"
                cellStyle3= "color:  #FA6400;background:#F7E8E8;font-weight:600;"
                cellStyle4="color:#3268A3;background:#fff;font-weight:600;"
                cellStyle5="color:#FA6400;background:#fff;font-weight:600;"
                if(columnIndex >= 0 && columnIndex < 1 && rowIndex<=1){
                   return cellStyle1;
                }
                if(columnIndex >= 1 && columnIndex < 5 && rowIndex===0){
                   return cellStyle2;
                }
                if(columnIndex >= 5 && columnIndex < 7 && rowIndex===0){
                   return cellStyle1;
                }
                if(columnIndex >= 7 && columnIndex < 8 && rowIndex===0){
                   return cellStyle3;
                }
                // if(columnIndex === 12 && rowIndex===1){
                //    return cellStyle1;
                // }
                if(columnIndex >= 1 && columnIndex < 14 && rowIndex===1){
                   return cellStyle4;
                }
                if(columnIndex >= 14 &&columnIndex < 19 && rowIndex===1){
                   return cellStyle5;
                }
                // if(columnIndex === 18 && rowIndex===1){
                //    return cellStyle3;
                // }
            },
            exportTable(id,name,startTime='',endTime=''){
              let dateVal = new Date()

              name = name +' ' + dateVal.getFullYear()+'-'+ (dateVal.getMonth()+1)
                this.$exportTable(id,name,startTime,endTime)
            },
            loadData(){
                this.loading = true;
                // console.log(this.form);
                this.request();
            },
            //重置
            reset(){
                this.form={
                    month:'',
                    year:'',
                }
                this.createTime=''
            },
            pickerChange(val){
              let arr = val.split('-')
              this.form.year = arr[0]
              this.form.month = arr[1]
            },
            request(){
                // 获取列表数据
                // this.tableData = [];
                services.getDispatchList(this.form).then(res => {
                    this.tableData = res;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.hoverBtn{
    :hover{
        // font-size:18px;
    }
    padding:10px 30px;

}
.titleColod{
    color:#0099FF;
}
.tipText{
    font-size: 14px;
    color: #0091FF;
    text-align: right;
    .tipDiv{
        margin-right: 20px;
        display: inline-block;
        text-align: bottom;
        cursor: pointer;
    }
}
.el-popover, .el-popper{
  font-size: 14px;
  .tipTextP{
    font-size: 14px;
    margin-bottom: 7px;
  }
}
p{
    line-height: 20px;
}
</style>
